export default "__VITE_ASSET__BTBWTkzG__"